(function () {
  function setButton(state, paused) {
    var button = state.button;
    var label = button.getAttribute(paused ? 'data-play-label' : 'data-pause-label');
    button.setAttribute('aria-label', label);
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    button.setAttribute('data-state', paused ? 'paused' : 'playing');
    var text = button.querySelector ? button.querySelector('.bn-filmstrip__toggle-text') : null;
    if (text) text.textContent = paused ? window.BionoboI18n.s_e30a9caca4ff3b7d75538a04 : window.BionoboI18n.s_9f428dc3d2faf26c11065520;
  }

  function play(state, explicit, reduce) {
    if (!explicit && (reduce.matches || state.userPaused)) return;
    var promise = state.video.play();
    setButton(state, false);
    if (promise && promise.catch) {
      promise.catch(function () {
        state.video.pause();
        setButton(state, true);
      });
    }
  }

  function pause(state, userAction) {
    state.video.pause();
    if (userAction) state.userPaused = true;
    setButton(state, true);
  }

  function init(root) {
    if (root.__bnFilmstripReady) return;
    root.__bnFilmstripReady = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cards = root.querySelectorAll('[data-bn-filmstrip-card]');
    var states = [];

    Array.prototype.forEach.call(cards, function (card) {
      var video = card.querySelector('[data-bn-filmstrip-video]');
      var button = card.querySelector('[data-bn-filmstrip-toggle]');
      if (!video || !button) return;

      var state = { video: video, button: button, userPaused: false };
      states.push(state);
      button.hidden = false;
      video.removeAttribute('controls');
      setButton(state, true);

      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (video.paused) {
          state.userPaused = false;
          play(state, true, reduce);
        } else {
          pause(state, true);
        }
      });
    });

    if (!states.length || !('IntersectionObserver' in window)) return;

    root.classList.add('is-enhanced');
    var stateByVideo = new Map();
    states.forEach(function (state) { stateByVideo.set(state.video, state); });

    var observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var state = stateByVideo.get(entry.target);
        if (!state) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.45) play(state, false, reduce);
        else pause(state, false);
      });
    }, { threshold: 0.45 });

    states.forEach(function (state) { observer.observe(state.video); });

    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        if (!reduce.matches) return;
        states.forEach(function (state) { pause(state, false); });
      });
    }
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-bn-filmstrip]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
